import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'clink-split-time',
    styleUrls: ['split-time.component.less'],
    templateUrl: 'split-time.component.html',
})
export class SplitTimeComponent implements OnInit {
    @Input() timePlaceholder = '统计时段';
    @Input() startHour: number; // 开始时间
    @Input() endHour: number; // 结束时间
    @Output() hour: EventEmitter<any> = new EventEmitter(); // 时间变化

    queryHour: any = { startHour: 0, endHour: 23 }; // 查询时间对象
    preHourArr = []; // 开始小时数组
    afterHourArr = []; // 结束小时数组
    popoverVisible = false; // 展示气泡卡片
    init = false;

    ngOnInit(): void {
        this.initHourArr();
        this.updateQueryHour();
    }

    /**
     * 初始化小时数组
     *
     * @memberof SplitTimeComponent
     */
    initHourArr(): void {
        for (let i = 0; i < 24; i++) {
            this.preHourArr.push(i);
        }
        for (let i = 1; i < 25; i++) {
            this.afterHourArr.push(i);
        }
    }

    /**
     * 更新选择时间
     *
     * @memberof SplitTimeComponent
     */
    updateQueryHour(): void {
        if (typeof this.startHour === 'number') {
            this.queryHour.startHour = this.startHour;
        }
        if (typeof this.endHour === 'number') {
            this.queryHour.endHour = this.endHour;
        }
    }

    /**
     * 显示/隐藏事件
     *
     * @param {*} event
     * @memberof SplitTimeComponent
     */
    popoverVisibleChange(event): void {
        if (event) {
            this.updateQueryHour();
        }
    }

    /**
     * 变更小时
     *
     * @memberof SplitTimeComponent
     */
    changeHour(): void {
        this.popoverVisible = false;
        this.init = true;
        this.startHour = this.queryHour.startHour;
        this.endHour = this.queryHour.endHour;
        this.hour.emit(this.queryHour);
    }

    /**
     * 起始时间
     *
     * @param {*} event
     * @memberof SplitTimeComponent
     */
    startChange(event): void {
        if (event >= this.queryHour.endHour) {
            this.queryHour.endHour = event + 1;
        }
    }
    /**
     * @desc 关闭menu时设置选择框中的值
     */
    toogleMenu(opened): void {
        if (!opened) {
            this.queryHour.startHour = this.startHour || 0;
            this.queryHour.endHour = this.endHour || 23;
        }
    }
}
